/* eslint-disable no-loop-func */
/* eslint-disable react-hooks/exhaustive-deps */
import {
	Box,
	Center,
	Flex,
	Image,
	ListItem,
	Popover,
	PopoverArrow,
	PopoverBody,
	PopoverCloseButton,
	PopoverContent,
	PopoverHeader,
	PopoverTrigger,
	Text,
	UnorderedList,
} from '@chakra-ui/react';
import { useEffect, useMemo, useState } from 'react';
import { AttachmentIcon } from '@chakra-ui/icons';
import { useTranslation } from 'react-i18next';
import DownloadAndViewButton from '../../../../components/Files/DownloadAndViewButton';
import LOGO from '../../../../assets/images/logo.png';
import Underlint from '../../../../assets/images/underline.png';
import RichTextViewer from '../../../../components/form/RichTextEditorField/viewer';
import useMoment from '../../../../hooks/useMoment';
import c from '../../../../constant';
import '../../style.css';

const rp = 'rp';
const np = 'np';
const rOc = 'Officials';
const rOf = 'Office';
const rDe = 'Department';
const rDd = 'Deputy Director General';
const rDg = 'Director General';

function Print({ type = null, npData = null, npSigns = null, isPreviewing = false, showBorder = false }) {
	const { t } = useTranslation();
	const { paperSolarDateString, paperLunarDateString, paperGeneralDateTimeString, paperWritingSignDateString } = useMoment();
	const [signer, setSigner] = useState(null);
	const [ofcSigner, setOfcSigner] = useState(null);
	const [offSigner, setOffSigner] = useState(null);
	const [deptSigner, setDeptSigner] = useState(null);
	const [ddgSigner, setDdgSigner] = useState(null);
	const [dgSigner, setDgSigner] = useState(null);
	const [rpSigning, setRpSigning] = useState(null);

	const signs = useMemo(() => {
		let localSigns = npSigns
			?.map((npSign) => npSign?.data)
			?.reduce((pre, cur, i) => {
				let localPre = pre;
				if (cur?.decisionAt) {
					localPre.push(cur);
				}
				return localPre;
			}, [])
			?.sort((a, b) => new Date(a?.decisionAt) - new Date(b?.decisionAt));
		return localSigns;
	}, [npSigns]);

	useEffect(() => {
		setSigner(signs?.find((sign, i) => i === 0));
		setOfcSigner(signs?.find((sign) => sign?.position === rOc));
		setOffSigner(signs?.find((sign) => sign?.position === rOf));
		setDeptSigner(signs?.find((sign) => sign?.position === rDe));
		setDdgSigner(signs?.find((sign) => sign?.position === rDd));
		setDgSigner(signs?.find((sign) => sign?.position === rDg));
	}, [signs]);

	useEffect(() => {
		if (type === rp) {
			if (true === npData?.isDepartmentLevel) {
				if (ofcSigner?.userReviewer?.id === signer?.userReviewer?.id) {
					setRpSigning({
						leftSigners: [deptSigner],
						rightSigners: [ofcSigner, offSigner],
						decisionAt: ofcSigner?.decisionAt,
					});
				} else if (offSigner?.userReviewer?.id === signer?.userReviewer?.id) {
					setRpSigning({
						leftSigners: [deptSigner],
						rightSigners: [offSigner],
						decisionAt: offSigner?.decisionAt,
					});
				} else if (deptSigner?.userReviewer?.id === signer?.userReviewer?.id) {
					setRpSigning({
						leftSigners: [],
						rightSigners: [deptSigner],
						decisionAt: deptSigner?.decisionAt,
					});
				}
			} else {
				if (ofcSigner?.userReviewer?.id === signer?.userReviewer?.id) {
					setRpSigning({
						leftSigners: [dgSigner, ddgSigner],
						rightSigners: [ofcSigner, offSigner, deptSigner],
						decisionAt: ofcSigner?.decisionAt,
					});
				} else if (offSigner?.userReviewer?.id === signer?.userReviewer?.id) {
					setRpSigning({
						leftSigners: [dgSigner, ddgSigner],
						rightSigners: [offSigner, deptSigner],
						decisionAt: offSigner?.decisionAt,
					});
				} else if (deptSigner?.userReviewer?.id === signer?.userReviewer?.id) {
					setRpSigning({
						leftSigners: [dgSigner, ddgSigner],
						rightSigners: [deptSigner],
						decisionAt: deptSigner?.decisionAt,
					});
				} else if (ddgSigner?.userReviewer?.id === signer?.userReviewer?.id) {
					setRpSigning({
						leftSigners: [dgSigner],
						rightSigners: [ddgSigner],
						decisionAt: ddgSigner?.decisionAt,
					});
				}
			}
		}
	}, [signer, ofcSigner, offSigner, deptSigner, ddgSigner, dgSigner, type]);

	const ReportSignBox = ({ people, ...props }) => {
		return (
			<Box {...props} className="signBox">
				{people?.decisionFile ? (
					<>
						<Image w="260px" h="390px" src={people?.decisionFile} />
					</>
				) : (
					<>
						{people?.userReviewer?.id === signer?.userReviewer?.id && (
							<>
								<Center mt={2}>
									<Text fontFamily="KhmerOSMuolLight" fontSize="16px">
										{people?.decision?.title}
									</Text>
								</Center>
								<Center mt={0}>
									<Text fontFamily="KhmerOSMuolLight" fontSize="16px">
										{people?.decision?.unit}
									</Text>
								</Center>
							</>
						)}
						{people?.decision?.decision && (
							<Center mt={4}>
								<Text
									fontFamily="KhmerOSSiemreap"
									whiteSpace="pre-line"
									fontSize="16px"
									color={c.penColor}
									fontWeight="bold"
									textAlign="center"
								>
									{people?.decision?.decision}
								</Text>
							</Center>
						)}
						{people?.decisionAt && people?.userReviewer?.id !== signer?.userReviewer?.id && (
							<>
								<Center mt={2} mb={4}>
									<Text fontFamily="KhmerOSSiemreap" fontSize="16px">
										{paperWritingSignDateString(people?.decisionAt)}
									</Text>
								</Center>
							</>
						)}
						<Box className="signBoxSpace">
							{people?.signatureImage?.file && (
								<Center mt={4}>
									<Image
										w="240px"
										h="135px"
										maxW="240px"
										maxH="135px"
										minW="240px"
										minH="135px"
										src={people?.signatureImage?.file}
										pointerEvents="none"
									/>
								</Center>
							)}
							<Center mt={4} mb={4}>
								<Text fontFamily="KhmerOSMuolLight" fontSize="16px" color={c.penColor}>
									{people?.userReviewer?.fullNameKhmer}
								</Text>
							</Center>
						</Box>
					</>
				)}
			</Box>
		);
	};

	return (
		<>
			{npData && (
				<center>
					<Box maxW="960px" minH="1350px" bg="white" borderWidth={showBorder ? 1 : 0} borderColor="gray.100">
						<page size="A4">
							<Flex>
								<Flex minW="210px" w="210px" align="center" direction="column">
									<Image mt="4px" src={LOGO} w="114px" h="114px" />
									<Text mt={1} color="#62B3ED" fontSize="16px" fontFamily="KhmerOSMuolLight">
										និយ័តករធានារ៉ាប់រងកម្ពុជា
									</Text>
									<Flex width="100%" justifyContent="flex-start" alignItems="center" mt={1} pl="1px" pr="1px">
										<Text fontSize="16px" fontFamily="KhmerOSSiemreap" mr={1}>
											លេខ៖
										</Text>
										<Text fontSize="16px" fontFamily="KhmerOSSiemreap">
											{npData?.number || <span>{Array.from({ length: 36 })?.reduce((pre, cur) => pre + '.', '')}</span>}
										</Text>
									</Flex>
								</Flex>
								<Flex flexGrow="1" alignItems="center" direction="column" mt="-32px">
									<Text fontSize="16px" fontFamily="KhmerOSMuolLight" color="#62B3ED">
										ព្រះរាជាណាចក្រកម្ពុជា
									</Text>
									<Text mt="4px" fontFamily="KhmerOSMuolLight" color="#62B3ED" fontSize="16px">
										ជាតិ សាសនា ព្រះមហាក្សត្រ
									</Text>
									<Image src={Underlint} h="auto" w="90px" />
								</Flex>
								<Flex w="190px" minW="190px"></Flex>
							</Flex>
							<Box w="100%">
								{type === np && (
									<center>
										<Text fontFamily="KhmerOSMuolLight" fontSize="16px" textDecoration="underline">
											កំណត់បង្ហាញរឿង
										</Text>
									</center>
								)}
								{type === rp && (
									<>
										{rpSigning && (
											<Flex flexDirection="column" justifyContent="center" alignItems="flex-end" my={6}>
												<Center mt={2}>
													<Text fontFamily="KhmerOSSiemreap" fontSize="16px">
														{paperLunarDateString(rpSigning?.decisionAt)}
													</Text>
												</Center>
												<Center mt={0}>
													<Text fontFamily="KhmerOSSiemreap" fontSize="16px">
														{paperSolarDateString(rpSigning?.decisionAt)}
													</Text>
												</Center>
											</Flex>
										)}
										<center>
											<Text fontFamily="KhmerOSMuolLight" fontSize="16px" textDecoration="none">
												សូមគោរពជូន
												<br />
												ឯកឧត្តមអគ្គនាយក នៃនិយ័តករធានារ៉ាប់រងកម្ពុជា
											</Text>
										</center>
									</>
								)}
							</Box>
							<Box pb={type === rp ? '0px' : '16px'} pt="10px">
								<Flex>
									<Box w="90px">
										<Text textAlign="left" fontFamily="KhmerOSMuolLight" pt="3px" pb="3px">
											កម្មវត្ថុ៖
										</Text>
									</Box>
									<Box width="100%">
										<RichTextViewer value={npData?.subject} />
									</Box>
								</Flex>
								{npData?.references?.length > 0 && (
									<Flex mt="16px">
										<Box w="90px">
											<Text textAlign="left" fontFamily="KhmerOSMuolLight" pt="3px" pb="3px">
												យោង៖
											</Text>
										</Box>
										<Box width="100%">
											{npData?.references?.map((reference, i) => (
												<Flex key={i} ml={npData?.references?.length > 1 ? -2 : 0}>
													{npData?.references?.length > 1 && (
														<span style={{ paddingTop: '3px', paddingBottom: '3px', marginLeft: '0px', marginRight: '2px' }}>
															&#8722;
														</span>
													)}
													<RichTextViewer value={reference?.description} />
													{isPreviewing && (
														<Flex className="hidden-print" justifyContent="flex-end" minWidth={12}>
															{reference?.file?.url && (
																<Popover>
																	<PopoverTrigger>
																		<AttachmentIcon cursor="pointer" mt={1} />
																	</PopoverTrigger>
																	<PopoverContent>
																		<PopoverArrow />
																		<PopoverCloseButton />
																		<PopoverHeader>{t('Attachment')}</PopoverHeader>
																		<PopoverBody>
																			<Flex justify={'center'}>
																				<DownloadAndViewButton
																					url={reference?.file?.url}
																					size={reference?.file?.size}
																				/>
																			</Flex>
																		</PopoverBody>
																	</PopoverContent>
																</Popover>
															)}
														</Flex>
													)}
												</Flex>
											))}
										</Box>
									</Flex>
								)}
								{npData?.attachings?.length > 0 && (
									<Flex mt="16px">
										<Box w="90px">
											<Text textAlign="left" fontFamily="KhmerOSMuolLight" pt="3px" pb="3px">
												ភ្ជាប់ជូន៖
											</Text>
										</Box>
										<Box width="100%">
											{npData?.attachings?.map((attaching, i) => (
												<Flex key={i} ml={npData?.attachings?.length > 1 ? -2 : 0}>
													{npData?.attachings?.length > 1 && (
														<span style={{ paddingTop: '3px', paddingBottom: '3px', marginLeft: '0px', marginRight: '2px' }}>
															&#8722;
														</span>
													)}
													<RichTextViewer value={attaching?.description} />
													{isPreviewing && (
														<Flex className="hidden-print" justifyContent="flex-end" minWidth={12}>
															{attaching?.file?.url && (
																<Popover>
																	<PopoverTrigger>
																		<AttachmentIcon cursor="pointer" mt={1} />
																	</PopoverTrigger>
																	<PopoverContent>
																		<PopoverArrow />
																		<PopoverCloseButton />
																		<PopoverHeader>{t('Attachment')}</PopoverHeader>
																		<PopoverBody>
																			<Flex justify={'center'}>
																				<DownloadAndViewButton
																					url={attaching?.file?.url}
																					size={attaching?.file?.size}
																				/>
																			</Flex>
																		</PopoverBody>
																	</PopoverContent>
																</Popover>
															)}
														</Flex>
													)}
												</Flex>
											))}
										</Box>
									</Flex>
								)}
							</Box>
							<Flex borderTop={type === rp ? '0px solid black' : '1px solid black'} flexGrow={1}>
								{type === np && (
									<Flex className="signBoxContainer" w="280px" direction="column">
										{true === npData?.isDepartmentLevel && (
											<>
												<Box className="signBox">
													<Center>
														<Text fontFamily="KhmerOSMuolLight" fontSize="16px">
															ការសម្រេចរបស់
															<br />
															នាយកដ្ឋាន
														</Text>
													</Center>
													<Center mt={2}>
														{deptSigner?.decisionAt ? (
															<Text fontFamily="KhmerOSSiemreap" fontSize="14px" letterSpacing="-0.8px">
																&#40;ចូល{paperGeneralDateTimeString(npData?.checkInDdgAt || deptSigner?.createdAt)}
																<br />
																ចេញ{paperGeneralDateTimeString(deptSigner?.decisionAt)}&#41;
															</Text>
														) : (
															<Text fontFamily="KhmerOSSiemreap" fontSize="14px">
																&#40;ចូលថ្ងៃទី...ខែ...គ.ស....
																<br />
																ចូលថ្ងៃទី...ខែ...គ.ស....&#41;
															</Text>
														)}
													</Center>
													<Box className="signBoxSpace">
														{deptSigner?.decisionAt && (
															<>
																{deptSigner?.decision?.decision && (
																	<Text
																		mt={2}
																		fontFamily="KhmerOSSiemreap"
																		whiteSpace="pre-line"
																		fontSize="16px"
																		color={c.penColor}
																		fontWeight="bold"
																		textAlign="center"
																	>
																		{deptSigner?.decision?.decision}
																	</Text>
																)}
																<Center mt={2}>
																	<Image
																		w="240px"
																		h="135px"
																		maxW="240px"
																		maxH="135px"
																		minW="240px"
																		minH="135px"
																		src={deptSigner?.signatureImage?.file}
																		pointerEvents="none"
																	/>
																</Center>
																<Center mt={2} mb={2}>
																	<Text fontFamily="KhmerOSMuolLight" fontSize="16px" color={c.penColor}>
																		{deptSigner?.userReviewer?.fullNameKhmer}
																	</Text>
																</Center>
															</>
														)}
														{deptSigner?.miscellaneous && (
															<Center mt={2} mb={2}>
																<Text fontFamily="KhmerOSSiemreap" fontSize="16px" color={c.penColor}>
																	{deptSigner?.miscellaneous?.description}
																</Text>
															</Center>
														)}
													</Box>
												</Box>
											</>
										)}
										{false === npData?.isDepartmentLevel && (
											<>
												<Box className="signBox">
													<Center>
														<Text fontFamily="KhmerOSMuolLight" fontSize="16px">
															ការសម្រេចរបស់
															<br />
															ឯកឧត្តមអគ្គនាយក
														</Text>
													</Center>
													<Center mt={2}>
														{dgSigner?.decisionAt ? (
															<Text fontFamily="KhmerOSSiemreap" fontSize="14px" letterSpacing="-0.8px">
																&#40;ចូល{paperGeneralDateTimeString(npData?.checkInDgAt || dgSigner?.createdAt)}
																<br />
																ចេញ{paperGeneralDateTimeString(dgSigner?.decisionAt)}&#41;
															</Text>
														) : (
															<Text fontFamily="KhmerOSSiemreap" fontSize="14px">
																&#40;ចូលថ្ងៃទី...ខែ...គ.ស....
																<br />
																ចូលថ្ងៃទី...ខែ...គ.ស....&#41;
															</Text>
														)}
													</Center>
													<Box className="signBoxSpace">
														{dgSigner?.decisionAt &&
															(dgSigner?.decisionFile ? (
																<>
																	<Image w="260px" h="390px" src={dgSigner?.decisionFile} />
																</>
															) : (
																<>
																	{dgSigner?.decision?.decision && (
																		<Text
																			mt={2}
																			fontFamily="KhmerOSSiemreap"
																			whiteSpace="pre-line"
																			fontSize="16px"
																			color={c.penColor}
																			fontWeight="bold"
																			textAlign="center"
																		>
																			{dgSigner?.decision?.decision}
																		</Text>
																	)}
																	<Center mt={2}>
																		<Image
																			w="240px"
																			h="135px"
																			maxW="240px"
																			maxH="135px"
																			minW="240px"
																			minH="135px"
																			src={dgSigner?.signatureImage?.file}
																			pointerEvents="none"
																		/>
																	</Center>
																	<Center mt={2} mb={2}>
																		<Text fontFamily="KhmerOSMuolLight" fontSize="16px" color={c.penColor}>
																			{dgSigner?.userReviewer?.fullNameKhmer}
																		</Text>
																	</Center>
																</>
															))}
														{dgSigner?.miscellaneous && (
															<Center mt={2} mb={2}>
																<Text fontFamily="KhmerOSSiemreap" fontSize="16px" color={c.penColor}>
																	{dgSigner?.miscellaneous?.description}
																</Text>
															</Center>
														)}
													</Box>
												</Box>
												<Box className="signBox">
													<Center>
														<Text fontFamily="KhmerOSMuolLight" fontSize="16px">
															យោបល់
															<br />
															អគ្គនាយករងទទួលបន្ទុក
														</Text>
													</Center>
													<Center mt={2}>
														{ddgSigner?.decisionAt ? (
															<Text fontFamily="KhmerOSSiemreap" fontSize="14px" letterSpacing="-0.8px">
																&#40;ចូល{paperGeneralDateTimeString(npData?.checkInDdgAt || ddgSigner?.createdAt)}
																<br />
																ចេញ{paperGeneralDateTimeString(ddgSigner?.decisionAt)}&#41;
															</Text>
														) : (
															<Text fontFamily="KhmerOSSiemreap" fontSize="14px">
																&#40;ចូលថ្ងៃទី...ខែ...គ.ស....
																<br />
																ចូលថ្ងៃទី...ខែ...គ.ស....&#41;
															</Text>
														)}
													</Center>
													<Box className="signBoxSpace">
														{ddgSigner?.decisionAt && (
															<>
																{ddgSigner?.decision?.decision && (
																	<Text
																		mt={2}
																		fontFamily="KhmerOSSiemreap"
																		whiteSpace="pre-line"
																		fontSize="16px"
																		color={c.penColor}
																		fontWeight="bold"
																		textAlign="center"
																	>
																		{ddgSigner?.decision?.decision}
																	</Text>
																)}
																<Center mt={2}>
																	<Image
																		w="240px"
																		h="135px"
																		maxW="240px"
																		maxH="135px"
																		minW="240px"
																		minH="135px"
																		src={ddgSigner?.signatureImage?.file}
																		pointerEvents="none"
																	/>
																</Center>
																<Center mt={2} mb={2}>
																	<Text fontFamily="KhmerOSMuolLight" fontSize="16px" color={c.penColor}>
																		{ddgSigner?.userReviewer?.fullNameKhmer}
																	</Text>
																</Center>
															</>
														)}
														{ddgSigner?.miscellaneous && (
															<Center mt={2} mb={2}>
																<Text fontFamily="KhmerOSSiemreap" fontSize="16px" color={c.penColor}>
																	{ddgSigner?.miscellaneous?.description}
																</Text>
															</Center>
														)}
													</Box>
												</Box>
											</>
										)}
									</Flex>
								)}
								<Box
									borderLeft={type === rp ? '0px solid black' : '1px solid black'}
									width={type === rp ? '848px' : '568px'}
									pl={type === rp ? 0 : 4}
									pr={type === rp ? 0 : 0}
									pt={type === rp ? 4 : 4}
									pb={type === rp ? 0 : 0}
								>
									{type === np && (
										<>
											{signer && offSigner && signer?.id === offSigner?.id && (
												<>
													<Center>
														<Text fontFamily="KhmerOSMuolLight" fontSize="16px">
															យោបល់ការិយាល័យជំនាញ
														</Text>
													</Center>
													<>
														{npData?.checkInAt && npData?.checkOutAt && (
															<Center mt={1}>
																<Text fontFamily="KhmerOSSiemreap" fontSize="14px">
																	&#40;ចូល{paperGeneralDateTimeString(npData?.checkInAt)} ចេញ
																	{paperGeneralDateTimeString(npData?.checkOutAt)}&#41;
																</Text>
															</Center>
														)}
													</>
												</>
											)}
											{signer && deptSigner && signer?.id === deptSigner?.id && (
												<Center>
													<Text fontFamily="KhmerOSMuolLight" fontSize="16px">
														យោបល់នាយកដ្ឋានជំនាញ
													</Text>
												</Center>
											)}
										</>
									)}

									<RichTextViewer value={npData?.description} />

									{type === np && (
										<Flex className="signBoxContainer" direction="column" justifyContent="center" alignItems="center" width="100%">
											{signer && offSigner && signer?.id === offSigner?.id && (
												<>
													<Box className="signBox">
														<Center>
															<Text fontFamily="KhmerOSSiemreap" fontSize="16px">
																{paperLunarDateString(offSigner?.decisionAt)}
															</Text>
														</Center>
														<Center>
															<Text fontFamily="KhmerOSSiemreap" fontSize="16px">
																{paperSolarDateString(offSigner?.decisionAt)}
															</Text>
														</Center>
														<Box mt={2}>
															<Center>
																<Text fontFamily="KhmerOSMuolLight" fontSize="16px">
																	{offSigner?.decision?.title}
																</Text>
															</Center>
															<Center>
																<Text fontFamily="KhmerOSMuolLight" fontSize="16px">
																	{offSigner?.decision?.unit}
																</Text>
															</Center>
														</Box>
														<Box className="signBoxSpace">
															<Center mt={2}>
																<Image
																	w="240px"
																	h="135px"
																	maxW="240px"
																	maxH="135px"
																	minW="240px"
																	minH="135px"
																	src={offSigner?.signatureImage?.file}
																	pointerEvents="none"
																/>
															</Center>
															<Center mt={2} mb={2}>
																<Text fontFamily="KhmerOSMuolLight" fontSize="16px" color={c.penColor}>
																	{offSigner?.userReviewer?.fullNameKhmer}
																</Text>
															</Center>
														</Box>
													</Box>
													{false === npData?.isDepartmentLevel && (
														<>
															{deptSigner && (
																<Box className="signBox">
																	<Center>
																		<Text fontFamily="KhmerOSMuolLight" fontSize="16px">
																			យោបល់នាយកដ្ឋានជំនាញ
																		</Text>
																	</Center>
																	<Center mt={2}>
																		<Text fontFamily="KhmerOSSiemreap" fontSize="14px">
																			&#40;ចូល{paperGeneralDateTimeString(npData?.checkOutAt || deptSigner?.createdAt)}{' '}
																			ចេញ
																			{paperGeneralDateTimeString(deptSigner?.decisionAt)}&#41;
																		</Text>
																	</Center>
																	{deptSigner?.decision?.decision && (
																		<Center mt={2}>
																			<Text
																				mt={2}
																				fontFamily="KhmerOSSiemreap"
																				whiteSpace="pre-line"
																				fontSize="16px"
																				color={c.penColor}
																				fontWeight="bold"
																				textAlign="center"
																			>
																				{deptSigner?.decision?.decision}
																			</Text>
																		</Center>
																	)}
																	<Box mt={2}>
																		<Center>
																			<Text fontFamily="KhmerOSMuolLight" fontSize="16px">
																				{deptSigner?.decision?.title}
																			</Text>
																		</Center>
																		<Center>
																			<Text fontFamily="KhmerOSMuolLight" fontSize="16px">
																				{deptSigner?.decision?.unit}
																			</Text>
																		</Center>
																	</Box>
																	<Box className="signBoxSpace">
																		<Center mt={2}>
																			<Image
																				w="240px"
																				h="135px"
																				maxW="240px"
																				maxH="135px"
																				minW="240px"
																				minH="135px"
																				src={deptSigner?.signatureImage?.file}
																				pointerEvents="none"
																			/>
																		</Center>
																		<Center mt={2} mb={2}>
																			<Text fontFamily="KhmerOSMuolLight" fontSize="16px" color={c.penColor}>
																				{deptSigner?.userReviewer?.fullNameKhmer}
																			</Text>
																		</Center>
																	</Box>
																</Box>
															)}
														</>
													)}
												</>
											)}
											{false === npData?.isDepartmentLevel && (
												<>
													{signer && deptSigner && signer?.id === deptSigner?.id && (
														<>
															<Box className="signBox">
																<Center>
																	<Text fontFamily="KhmerOSSiemreap" fontSize="16px">
																		{paperLunarDateString(deptSigner?.decisionAt)}
																	</Text>
																</Center>
																<Center>
																	<Text fontFamily="KhmerOSSiemreap" fontSize="16px">
																		{paperSolarDateString(deptSigner?.decisionAt)}
																	</Text>
																</Center>
																<Box mt={2}>
																	<Center>
																		<Text fontFamily="KhmerOSMuolLight" fontSize="16px">
																			{deptSigner?.decision?.title}
																		</Text>
																	</Center>
																	<Center>
																		<Text fontFamily="KhmerOSMuolLight" fontSize="16px">
																			{deptSigner?.decision?.unit}
																		</Text>
																	</Center>
																</Box>
																<Box className="signBoxSpace">
																	<Center mt={2}>
																		<Image
																			w="240px"
																			h="135px"
																			maxW="240px"
																			maxH="135px"
																			minW="240px"
																			minH="135px"
																			src={deptSigner?.signatureImage?.file}
																			pointerEvents="none"
																		/>
																	</Center>
																	<Center mt={2} mb={2}>
																		<Text fontFamily="KhmerOSMuolLight" fontSize="16px" color={c.penColor}>
																			{deptSigner?.userReviewer?.fullNameKhmer}
																		</Text>
																	</Center>
																</Box>
															</Box>
														</>
													)}
												</>
											)}
										</Flex>
									)}
									{type === rp && (
										<>
											{rpSigning && (
												<Flex flexGrow={1}>
													<Box flexGrow={1} className="signBoxContainer">
														{rpSigning?.leftSigners?.map((leftSigner, i) => {
															return <ReportSignBox key={i} people={leftSigner} />;
														})}
													</Box>
													<Box flexGrow={1} className="signBoxContainer">
														{rpSigning?.rightSigners?.map((rightSigner, i) => {
															return <ReportSignBox key={i} people={rightSigner} />;
														})}
													</Box>
												</Flex>
											)}
										</>
									)}
								</Box>
							</Flex>
						</page>
					</Box>
					{isPreviewing && npData?.attachments?.length > 0 && (
						<Box className="hidden-print" maxW="960px" mt={2}>
							<Text fontSize="md" fontWeight="bold" textAlign="left">
								{t('Other Attachments')}
							</Text>
							{npData?.attachments?.map((attachment, i) => (
								<UnorderedList key={i}>
									<ListItem _hover={{ bg: 'gray.100' }}>
										<Flex flex={1} justifyContent="flex-start" alignItems="center">
											<Text fontSize="md" fontWeight="normal">
												{attachment?.label}
											</Text>
											<Flex justifyContent="flex-end" alignItems="center" minWidth={12}>
												{attachment?.file?.url && (
													<Popover>
														<PopoverTrigger>
															<AttachmentIcon cursor="pointer" mt={1} />
														</PopoverTrigger>
														<PopoverContent>
															<PopoverArrow />
															<PopoverCloseButton />
															<PopoverHeader>{t('File (office)')}</PopoverHeader>
															<PopoverBody>
																<Flex justify={'center'}>
																	<DownloadAndViewButton url={attachment?.file?.url} size={attachment?.file?.size} />
																</Flex>
															</PopoverBody>
														</PopoverContent>
													</Popover>
												)}
											</Flex>
											<Flex justifyContent="flex-end" alignItems="center" minWidth={12}>
												{attachment?.pdf?.url && (
													<Popover>
														<PopoverTrigger>
															<AttachmentIcon cursor="pointer" mt={1} />
														</PopoverTrigger>
														<PopoverContent>
															<PopoverArrow />
															<PopoverCloseButton />
															<PopoverHeader>{t('File (pdf)')}</PopoverHeader>
															<PopoverBody>
																<Flex justify={'center'}>
																	<DownloadAndViewButton url={attachment?.pdf?.url} size={attachment?.pdf?.size} />
																</Flex>
															</PopoverBody>
														</PopoverContent>
													</Popover>
												)}
											</Flex>
										</Flex>
									</ListItem>
								</UnorderedList>
							))}
						</Box>
					)}
				</center>
			)}
		</>
	);
}

export default Print;
